import React from 'react';

import { Box } from 'ui/box';

const ReportAssignmentHeader = (): React.JSX.Element => {
  const headerCellStyle =
    'bg-navy-50 text-navy-500 text-xs tracking-[1.2px] pl-4 border-r-2 border-white font-semibold py-3 px-4';

  return (
    <Box sx={{ overflow: 'hidden', borderRadius: '0.5rem' }}>
      <table className="w-full table-fixed">
        <thead>
          <tr>
            <th className={`${headerCellStyle} px-0 w-[5%]`}></th>
            <th className={`${headerCellStyle} w-[40%] text-left`}>
              REPORT ASSIGNMENT
            </th>
            <th className={`${headerCellStyle} w-[15%]`}>REPORT ACCESS</th>
            <th className={`${headerCellStyle} w-[20%]`}>
              NEW USER DEFAULT
            </th>
            <th className={`${headerCellStyle} w-[20%]`}>
              DATA ISSUE VISIBILITY
            </th>
          </tr>
        </thead>
      </table>
    </Box>
  );
};

export default React.memo(ReportAssignmentHeader);
